import { useParams, useNavigate } from 'react-router-dom';
import PostSessionTab from './tabs/PostSessionTab';
import tokenStorage from '../../utils/tokenStorage';

/**
 * Post-Session Dashboard — thin route wrapper around PostSessionTab.
 * PostSessionTab carries the full UI (sidebar, action plans, reflections, manager code).
 * This page resolves sessionId/participantId and wires Back.
 */
const PostSessionDashboardPage = () => {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  const participant = tokenStorage.getParticipantData(sessionId) || {};
  const participantId = participant.participantId || participant.id;

  return (
    <PostSessionTab
      sessionId={sessionId}
      participantId={participantId}
      onBack={() => navigate(`/session/${sessionId}/lobby?view=welcome`)}
    />
  );
};

export default PostSessionDashboardPage;
